import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  api: string;
  constructor(private http: HttpClient) {
    this.api = `${environment.api}/user`;
  }

  uploadFile(file: File, name: string, type: string) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('name', name);
    fd.append('type', type);
    return this.http.post(`${this.api}/`, fd, { observe: 'response' });
  }

  viewProfile() {
    return this.http.get<User>(`${this.api}/profile`, { observe: 'body' });
  }

  updateProfile(payload: User | FormData) {
    return this.http.post<User>(`${this.api}/profile`, payload, {
      observe: 'body',
    });
  }

  uploadProfileImage(image: File) {
    const formData = new FormData();
    formData.append('image', image);
    return this.http.post<{ path: string }>(
      `${this.api}/profile/image`,
      formData,
      { observe: 'body' }
    );
  }

  removeProfileImage() {
    return this.http.post(
      `${this.api}/profile/image`,
      { remove: true },
      { observe: 'body' }
    );
  }

  // FAE methods
  viewFaeProfile() {
    return this.http.get<User>(`${environment.api}/fae/profile`, {
      observe: 'body',
    });
  }

  updateFaeProfile(payload: FormData) {
    return this.http.post<User>(`${environment.api}/fae/profile`, payload, {
      observe: 'body',
    });
  }

  requestImage(imageUrl: string) {
    return this.http
      .get(imageUrl, { responseType: 'blob' })
  }

  
}
